import { createFileRoute, redirect } from "@tanstack/react-router";
import { apiQuery } from "@/client/lib/api";
import { pageHead } from "@/client/lib/page";
import { LoginPageView } from "@/client/modules/auth/login-page";

export const Route = createFileRoute("/entrar")({
  validateSearch: (s: Record<string, unknown>): { de?: string } => ({ de: s.de as string | undefined }),
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.fetchQuery(apiQuery("auth", "me", {}));
    if (me.user) throw redirect({ to: "/app" });
  },
  head: () => pageHead("Entrar"),
  component: LoginPageView,
});
